import React, { useEffect, useMemo, useState } from "react";

import {Redirect, Route, Switch, useLocation} from "react-router-dom";

import {useDispatch, useSelector} from "react-redux";
import {forwardingPath, forwardingPathQr, getLoggedIn, setForwardingPath, setForwardingPathQr} from "../../redux/reducers/login-reducer";

import {adminRoutes, notFoundRoute, privateRoutes, publicRoutes} from "../../router";
import {RouteNames} from "../../router/consts";
import {getProfile} from "../../redux/reducers/user-profile-reducer";

import { getRoute } from "../../utils/getRoute";
import {  downloadActFile, getActData, getInfoAct, getInfoViolation, getQrAct, getViolation } from "../../redux/reducers/act-reducer";
import { useRedirect } from "../../hooks/useRedirect";
import { deleteSlash } from "../../utils/fuctions";
import { getProjects } from "../../redux/reducers/project-reducer";
import { setLibraryTree } from "../../redux/reducers/library-reducer";

const getPublicRouteKey = (id) => `public-route-${id}`
const getPrivateRouteKey = (id) => `private-route-${id}`
const getAdminRouteKey = (id) => `admin-route-${id}`

export const AuthRouter = () => {
    const ForwadingPath = useSelector(forwardingPath)
    const dispatch = useDispatch();
    const isLoggedIn = useSelector(getLoggedIn);
    const {user} = useSelector(getProfile);
    const routeGet = getRoute(user?.role);
    const location = useLocation();
    const infoAct = useSelector(getInfoAct)
    const infoViolation = useSelector(getInfoViolation)
    const {selectedProject} = useSelector(getProjects)

    useEffect(() => {
        if (location.pathname !== '/login' && location.pathname !== '/' ) { 
           
            if (location.pathname.includes('/qrcode/')) {
                dispatch(setForwardingPathQr(deleteSlash(location.pathname.substring(8))))
                dispatch(getQrAct(deleteSlash(location.pathname.substring(8))))
            } else if (location.pathname.includes('/qr_violation/')) {
                dispatch(getViolation(deleteSlash(location.pathname.substring(14))))
                
            } else {dispatch(setForwardingPath(location.pathname))}
        }
    },[location.pathname])   

    useEffect(() => {
        dispatch(setLibraryTree([]))
    }, [selectedProject])


    useEffect(() => {
        if (infoViolation !== null) {
            dispatch(getActData(infoViolation.act_id))
        }
        
    },[infoViolation])

    useEffect(() => {
        if (infoAct !== null && infoViolation === null && isLoggedIn)  {
            downloadActFile(infoAct.id)
        }
    },[ infoAct])

    const truePath = 
        infoViolation !== null 
            ? user?.is_staff 
                ? RouteNames.PODR_PAGE : RouteNames.HOME 

            : infoAct === null 
                ? isLoggedIn 
                    ? ForwadingPath : ForwadingPath 
                : ForwadingPath

   
   
    
    return  <Switch>
        
        {publicRoutes.map((route, id) => <Route key={getPublicRouteKey(id)} {...route}/>)}
        {isLoggedIn && user?.is_staff && 
                <> 
                    <Redirect to={truePath}/>
                    {adminRoutes.map((route, id) => <Route key={getPrivateRouteKey(id)} {...route}/> )}

                </>  }
        {isLoggedIn ? (user?.role === 'safety_engineer' || user?.role === 'project_manager') ? 
                <>
                    <Redirect to={truePath}/>
                    {routeGet.map((route, id) => <Route key={getPrivateRouteKey(id)} {...route}/> )}

                </>
           :    
                <>
                    <Redirect to={truePath}/>
                    {routeGet.map((route, id) => <Route key={getPrivateRouteKey(id)} {...route}/> )}

                </> 
            : <Redirect to={RouteNames.LOGIN}/>
        }
        <Route {...notFoundRoute}/>
        <Route render={() => <Redirect to={RouteNames.NOT_FOUND}/>}/>
    </Switch>
}
